import { useEffect } from "react";

import { useIsModerator } from "@/features/participants/api/is-moderator";
import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";

export async function shareScreen(): Promise<void> {
  const vidyoSDK = useVidyoStore.getState().vidyoSDK;
  const setIsSharing = useVidyoStore.getState().screenShare.setIsSharing;

  try {
    await vidyoSDK?.RegisterLocalWindowShareEventListener({
      onAdded: async (localWindowShare) => {
        try {
          await vidyoSDK?.SelectLocalWindowShareAdvanced({
            localWindowShare,
            options: {
              enableAudio: true,
              enableHighFramerate: false,
            },
          });
        } catch (e) {
          console.error("Error on SelectLocalWindowShareAdvanced:", e);
        }
      },
      onRemoved: () => {
        setIsSharing(false);
      },
      onSelected: (localWindowShare) => {
        // If localWindowShare is null, it means that the user has stopped sharing
        setIsSharing(!!localWindowShare);
      },
      onStateUpdated: (localWindowShare, state) =>
        console.info("state update sharing", localWindowShare, state),
    });
  } catch (e) {
    console.error("Error on RegisterLocalWindowShareEventListener:", e);
    //TODO add error handling
  }
}

export async function stopShareScreen(): Promise<void> {
  const vidyoSDK = useVidyoStore.getState().vidyoSDK;
  await vidyoSDK?.SelectLocalWindowShare({ localWindowShare: null });
  await vidyoSDK?.UnregisterLocalWindowShareEventListener();
}

export function useScreenShareGuard() {
  const isModerator = useIsModerator();

  const isUserSharingScreen = useVidyoStore(
    (store) => store.screenShare.isSharing,
  );

  const canUserShareScreen = useVidyoStore(
    (store) => store.screenShare.isParticipantScreenSharing,
  );

  const canIShareScreen = isModerator || canUserShareScreen;

  useEffect(() => {
    if (isUserSharingScreen && !canIShareScreen) {
      stopShareScreen().catch((error) => {
        console.error("Failed to stop screen sharing:", error);
      });
    }
  }, [isUserSharingScreen, canIShareScreen]);
}
